import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import React from "react";
import Markdown from "react-markdown";
import { COLOR_GREY_12 } from "shared/theme/colors";
import { StarsIcon } from "shared/theme/icons/StarIcon";
import { useCustomerTicketsPage } from "../../../../../../../../../context";

const StyledAISummaryContainer = styled(Box)`
  overflow-y: scroll;
  font-size: 0.75rem;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const StyledTitleContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${COLOR_GREY_12};
  font-weight: bold;
`;

const AISummary = () => {
  const { selectedTicket } = useCustomerTicketsPage();

  if (!selectedTicket || !selectedTicket.summary) {
    return null;
  }

  return (
    <StyledAISummaryContainer>
      <StyledTitleContainer>
        <StarsIcon /> AI Summary
      </StyledTitleContainer>
      <Markdown>{selectedTicket.summary}</Markdown>
    </StyledAISummaryContainer>
  );
};

export default AISummary;
